import * as React from 'react';
import { SVGProps } from 'react';

const SvgDoge = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      fill="#988430"
    />
    <path
      d="M12 21.68c5.346 0 9.68-4.334 9.68-9.68S17.346 2.32 12 2.32 2.32 6.654 2.32 12s4.334 9.68 9.68 9.68Z"
      fill="#7A6A2A"
    />
    <path d="M12 21.476a9.476 9.476 0 1 0 0-18.952 9.476 9.476 0 1 0 0 18.952Z" fill="#BA9F33" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.372 10.932-.171-.155a16.098 16.098 0 0 0-.169-.156l-.168-.16c-.027-.027-.056-.051-.084-.079l-.087-.076c-.224-.212-.448-.424-.669-.636.229.209.452.416.68.628l.08.08c.027.027.056.051.083.079l.169.155c.056.052.111.103.168.16.057.056.112.108.168.16ZM3.408 10.9s.812.084 1.209.14c.367.053 1.516.229 1.516.229L3.408 10.9Zm0 0c.228.02.456.044.684.068.117.011.228.024.34.036l.172.019.168.024.68.109.34.056.34.06a7.893 7.893 0 0 1-.34-.044l-.34-.048-.68-.1c-.057-.008-.112-.02-.168-.028l-.172-.02c-.112-.01-.228-.027-.34-.04a20.057 20.057 0 0 1-.684-.092Zm2.644.58s-.867.22-1.16.305c-.288.08-1.16.345-1.16.345l2.32-.65Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.052 11.48c-.193.057-.384.112-.58.164l-.579.155-.576.169-.288.079-.291.08c.095-.033.193-.065.288-.093l.288-.092.576-.177c.196-.048.388-.1.584-.147.186-.047.382-.094.578-.137Zm-2.2 1.184a89.61 89.61 0 0 0 1.452-.669c.128-.06.5-.192.5-.192l-1.951.86Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.853 12.664c.084-.032.163-.072.244-.109l.24-.112.48-.23c.16-.077.316-.16.48-.232a3.26 3.26 0 0 1 .253-.093l.128-.04c.044-.011.084-.024.128-.036-.16.076-.328.141-.488.216-.16.079-.324.144-.49.215l-.488.215c-.164.066-.324.137-.487.206Zm.107.447s.996-.584 1.34-.771c.179-.1.76-.389.76-.389l-2.1 1.16Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m3.96 13.112.51-.316.257-.155.26-.152c.088-.052.172-.104.26-.152a.93.93 0 0 1 .133-.068l.136-.068c.18-.088.36-.177.549-.253-.172.109-.348.201-.524.296-.088.049-.177.093-.264.141-.087.049-.172.1-.26.148-.088.051-.172.1-.261.147l-.264.144-.532.288Zm2.092-1.033-.82.628c-.201.152-.792.58-.792.58l1.612-1.208Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.608 15.916-.317-.6.185-.751 1.315-.508-.56-1.15.277-1.16.52-1.038 1.605-.253 1.18-1.124 2.546.192.5 2.724-.963 3.428-.548 1.776-2.224.084-1.032-.716-1.209-.504-1.275-.4Z"
      fill="#E2CC85"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.508 15.896s-.307.141-.832.109c-.152-.204-1.215-.3-1.215-.3s-.132-.04-.367.057c-.236.096-.46.084-.668.136-.209.052-.416-.22-.576-.277-.16-.06-.372-.204-.372-.204l-.448-.043-.9-.38L6.7 13.57l-.388.608-.12.752.433.892 1.163 1.06 2.269.575 1.344-.396 1.685-.712.422-.453Z"
      fill="#F1D789"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.448 10.864.288-.872.343-.563 1.105-.092-.331.967-.924 1.644.383 1.468-.68.34-.208-.32-.168-.735-.012-.826.204-1.01Z"
      fill="#F4ECB4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.688 15.837-.212-.296s-.057-.141-.024-.264c.032-.125.027-.133.01-.18-.015-.047-.151-.209-.143-.348.008-.14-.011-.188.092-.3.108-.108.076-.295.076-.295l.14.087.033-.048s.052.04.052.103c.01-.087-.036-.492.07-.584.108-.092.297.432.297.432l-.117-.76-.299-.78-.532-.712-.032-.785v-.068s-.245.375-.313.672c-.048.204.068.451.044.744-.02.291-.044.269.027.384.072.116.245.353.177.524-.06.148-.264.044-.264.044s-.04.12-.095.164a.362.362 0 0 0-.08-.16c-.003.027-.011.064-.011.064s-.036-.111-.071-.252c-.049-.188-.1-.435-.147-.568-.02.076-.068.307-.068.307l.027.356.133.489.128.32.124.392.109.263.087.2.076.452.367.388.196.088.143-.073Z"
      fill="#F3E19D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.64 10.152s-.263.448-.339.9c-.076.451-.144.929-.096 1.543.049.62.14 1 .215 1.272.128.452.46 1.08.46 1.08l.011-.025a1.708 1.708 0 0 1-.133-.331c-.043-.172-.06-.376-.1-.468-.036-.092-.095-.171-.125-.285-.027-.108-.032-.28-.116-.407a.826.826 0 0 1-.092-.324c-.017-.204.008-.432-.012-.62-.035-.312-.06-.524-.027-.688.032-.163.2-.627.304-.996.068-.237.028-.436.152-.641.125-.204.2-.384.228-.508.032-.114-.33.498-.33.498Z"
      fill="#F2E8B0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.892 9.973s-.136.04-.201.111c-.065.068-.092.125-.18.24-.087.115-.092.208-.163.352-.071.141-.228.353-.248.43-.02.075-.052.431-.092.6-.036.168.04.375.04.375l.093-.02s0 .12.092.201c.092.08.108-.269.108-.269l.345-1.163.52-.353.056-.284-.37-.22Z"
      fill="#F5EEC0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.144 10.5s-.244.016-.364.104c-.049.035-.068.064-.12.108-.095.08-.192.152-.24.256-.051.103-.108.26-.146.556-.017.125-.017.24-.028.34-.016.136-.04.245-.028.32.017.156.177.237.192.413l.332-.168.313-1.232.663-.416-.375-.42-.2.138.001.001Z"
      fill="#E6DB9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.394 18.792.004-.036c.048-.416.057-.732.092-.93.052-.28.088-.383.08-.488-.012-.168-.025-.291-.009-.42.025-.172.193-.376.188-.517-.003-.111-.06-.184-.108-.252a8.836 8.836 0 0 1-.088-.125s.332-.228.329-1.147a.086.086 0 0 1 .02.008l.163.464.111.136.43.8.551.535.815.549.512.556.052 1.484-.669.867-.11.199a9.507 9.507 0 0 1-2.363-1.683Z"
      fill="#E5CB7A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.435 20.212s.012-.184.164-.304c.024.04.04.08.035.108a.965.965 0 0 1 .656-.44c.435-.08.54-.396.54-.396l.924-.84 1.057-.973 1.284-.451.6-.148s.012.044-.01.141a2.92 2.92 0 0 0 .616-.155c.104-.04.2-.057.252-.003.076.071.088.24.093.34.124-.028.268-.148.384-.136.184.02.348.236.535.236.248 0 .36-.152.533-.272.103-.071.252-.16.336-.22.2-.147 2.324-.796 2.324-.796l.744.048.12.8-.064 2.09-.024.022-3.384 1.768-4.691.72a9.409 9.409 0 0 1-3-1.032l-.023-.107Z"
      fill="#D8C173"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.678 19.058c.067-.14.127-.256.138-.297.008.084.023.268.054.464a9.917 9.917 0 0 1-.192-.167Z"
      fill="#F1D789"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.105 21.025.607-.169.052.016s.027.016.027.071c.076-.043.141-.035.188-.064.024.051.048.223.155.244.112.024.232-.049.353-.14.12-.096.256-.216.36-.265.037.07.07.142.1.216.135-.109.372-.549.708-.54.098-.23.26-.427.468-.566.312-.212.508-.228.752-.208.097-.126.217-.233.353-.316.04.016.152.084.291.02.14-.065.3-.316.508-.348a.49.49 0 0 1 .324.068s.608-.604 1.027-.805c-.016-.048-.048-.23.444-.636.027.025.008.093.027.096.008 0 .128-.051.28-.168.188-.14.413-.288.548-.328.256-.076.528.079.528.079a.241.241 0 0 1 .076-.036 1.01 1.01 0 0 0 .147-.032c-.003.085.044.229 0 .353a.79.79 0 0 0 .16.068c-.027.06-.087.212-.187.285.084.04.095.087.215.128a2.372 2.372 0 0 0-.164.256c-.035.076-.163.391-.22.511-.06.12-.14.34-.18.384-.038.044-.179.231-.287.324.096-.036.488-.156.655-.201l-.543.805a9.495 9.495 0 0 1-7.773.9l.001-.002Z"
      fill="#E0CD81"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.184 10.456s-.14 0-.168.02c-.028.02.14.06.192.08.052.019.164.108.193.179.027.068 1.011.464 1.011.464l.696-.035.24-.332-.457-.4.32-.943-.423.068-1.02.608-.511.196-.073.095Z"
      fill="#DFC57C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.712 10.769a.108.108 0 0 0 .096.051c.144 0 .277.036.332.109.092.116.348.489.348.489l.611.22.04-.72-.669-.465-.76.28v.035h.002Z"
      fill="#E5CC7C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.592 11.036s.112.008.252-.044c.141-.052.373-.164.473-.12.14.06.112.248.264.416.092.104.26.1.356.212.095.112.424.06.424.06l.124.672-.5.641-.163.796h-.676l-.618-.245-.304-.736.152-.744.216-.908Z"
      fill="#D2C281"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.9 11.068a.185.185 0 0 0 .052.008c-.02.016-.06.052-.044.144s.068.209.024.28a.35.35 0 0 1 .076.133c.028.079.036.152.215.163a.373.373 0 0 0-.07.057s.124.108.187.208c.065-.002.236-.056.236-.056l.036.024.076-.031s-.071-.028-.02-.201c.049-.152.093-.144.096-.155.004-.012.036-.172.036-.237.024-.084.044-.34.044-.34l-.052-.564-.291-.176-.237-.23-.223.422-.148.146-.01.364.017.04Z"
      fill="#E2C270"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 10.595s.052.148.072.261a.249.249 0 0 0 .01-.068s.041.223.05.316c.016-.004.031-.008.035.008.004.016.04.195.032.296a.806.806 0 0 1 .272-.272.476.476 0 0 1 .22-.087c.124-.004.215.079.364.079.36 0 .684-.264.924-.345.176-.06.328-.103.435-.2.052-.044.144-.141.228-.285.112-.192.228-.36.345-.38a.723.723 0 0 1-.16.01s.036-.035.096-.083c.06-.049.133-.109.236-.109.185 0 .277.028.38.028a.517.517 0 0 0 .164-.028s.108.076.353.076c.244.004.407.025.535.036.128.011.557-.036.68-.032.08.003.159.022.231.057l-.396-1.152-1.424-1.245-.848.6-1.305 1.304-1.262.468-.264.296v.451H10.6Z"
      fill="#CCB360"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.432 9.935s.036-.035.095-.084c.06-.048.133-.108.237-.108.184 0 .276.027.38.027a.515.515 0 0 0 .163-.027s.109.076.353.076c.245.003.408.024.536.035.128.011.556-.035.68-.032.08.003.158.022.23.057l-.179-.52-.208-.396-.596-.652-.72-.424c-.003-.003-.248-.068-.248-.068l-.647.392-.587 1.519-.012.32.38.18c.096-.16.201-.288.3-.305-.09.01-.157.01-.157.01Z"
      fill="#D5B457"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.424 10.044c-.057.003-.104-.008-.117-.049-.048-.136-.087-.155-.128-.155-.04 0-.095.087-.128.095-.032.008-.07-.1-.07-.1l-.036-.016s-.21.136-.356.296c-.148.16-.389.432-.497.48-.108.049-.48.065-.608.093a.79.79 0 0 0-.288.14c-.02.021.057.044.068.065.011.02-.125.011-.136.032-.008.016.032.108.052.155a.263.263 0 0 1 .111-.027c.125-.003.216.08.364.08.36 0 .685-.265.924-.345.177-.06.329-.104.436-.201.051-.044.144-.141.228-.285.061-.099.121-.19.181-.259Z"
      fill="#D2B257"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.272 18.052s-.032-.12-.329-.429c-.084-.087-.135-.16-.192-.212-.14-.133-.223-.168-.324-.244-.22-.164-.46-.164-.644-.364-.184-.201-.4-.584-.548-.976a6.563 6.563 0 0 1-.188-.528c0-.01.04-.087.092-.076.052.012.052.112.065.136.026.04.055.077.087.112.076.087.185.192.24.348-.012-.133-.057-.28-.057-.28s.285.18.528.367c.244.188.344.253.416.372.07.12.239.436.32.528.08.092 1.184.44 1.184.44l.524.391.261.572-.204.32-.391.084-.636-.285-.204-.276Z"
      fill="#D2B159"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.86 16.084s.132.212.455.413c.292.176.753.336 1.164.432.236.056.472.1.684.103.572.008.965-.155 1.452-.208.264-.028.587-.049.924-.128.432-.104.688-.22 1.035-.384.253-.117.484-.204.672-.316.264-.155.456-.328.68-.38-.028.076-.057.212-.277.353.116-.004.277-.012.277-.012s-.156.093-.43.3c-.168.128-.39.344-.619.488-.147.093-.308.16-.413.216-.256.14-.359.212-.527.384.06-.004.065 0 .065 0s-.212.027-.364.108c-.032 0-.088-.011-.185.016-.076.024-.176.08-.28.109-.147.043-.196.024-.196.024l.025.048s-.192-.003-.256.004c.01.003.008.008.008.008a.1.1 0 0 0-.032.011.334.334 0 0 1-.1.044c-.02.003-.036.003-.06.008.008.02.07.128.1.192-.024.016-.389.291-.389.291.012.018.021.037.028.057.011.035.016.087.028.111.027.049.043.057.043.057s-.043.008-.12.027c-.064.017-.144.044-.256.06a.997.997 0 0 1-.103.008c.016.036.087.172-.044.329-.131.157-.171.18-.212.28a.434.434 0 0 0-.065-.04c-.043-.02-.103-.05-.124-.088a1.034 1.034 0 0 1-.049.152c-.04.108-.1.215-.111.296-.044-.048-.125-.144-.237-.124-.111.019-.2.171-.22.215 0-.028-.019-.049-.024-.016a1.23 1.23 0 0 1-.408.708c-.003-.076-.003-.244-.01-.299-.033.032-.072.08-.305.18-.228.1-.192.2-.192.2s-.02-.16.103-.328c.125-.168.201-.248.201-.26a.072.072 0 0 0-.016-.036c-.016-.017-.049-.036-.049-.049.02-.008.212-.1.201-.291a.517.517 0 0 0-.136-.324c-.008-.008.076-.068.065-.087-.008-.011-.112-.088-.125-.128a.374.374 0 0 1 .016-.071c.012-.036.02-.06.017-.084a.673.673 0 0 0-.065-.164c.011.003.092 0 .092 0s-.065-.103-.076-.152c-.011-.049-.036-.176-.048-.2.027.003.095.007.095 0 .003-.025-.06-.065-.032-.097.02.004.057.02.092.065-.02-.052-.052-.152-.12-.192a.294.294 0 0 1 .237.016.318.318 0 0 1 .128.136l.144.108c.1.08.228.192.432.272.043.024.155.024.236.008a.363.363 0 0 0 .1-.04.18.18 0 0 1 .036-.017.777.777 0 0 0-.06-.1c.028 0 .06.003.06.003s.02-.043-.068-.128c.02-.02.044-.032.044-.064-.028-.004-.076-.044-.088-.06.016-.012.04-.049.068-.06-.024-.02-.084-.1-.111-.108a.518.518 0 0 0 .076-.036s-.136-.036-.18-.065c-.044-.032-.108-.087-.147-.103-.04-.017-.112-.025-.141-.057.027.008.071 0 .104 0 .024 0 .035.003.043.003-.003-.011-.003-.035.06-.044a.298.298 0 0 0 .088-.027s-.06-.003-.128-.068c-.069-.065-.125-.117-.164-.125-.04-.008-.116.028-.163.025-.065-.008-.093-.04-.093-.04s-.215.019-.692-.273c-.413-.252-.592-.475-.592-.475a.715.715 0 0 1-.112-.052c-.155-.081-.37-.25-.364-.47v.002Z"
      fill="#C2A44D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.812 6.372a.21.21 0 0 1 .096.065c.076.087.125.252-.048.429.068.024.096.032.155.024-.06.071-.196.223-.204.356-.008.108.06.14.06.14s-.104.12-.109.32a1.3 1.3 0 0 1 .16-.151 4.25 4.25 0 0 1 .397-.272.228.228 0 0 0 .011.084s.209-.172.384-.095c.08.035.044.147.044.147s.108-.04.185.035c.075.076.183.273.238.349.024.035.088.103.152.208.088.148.162.303.22.465.004-.084.025-.215.264-.133.24.084.511.26.74.608.228.347.284.74.4.889.116.144.235.383.244.484.008.1-.036.424.203 1.3.068-.273.172-.876.172-.876l.057-.533.064-1.647-1.72-1.429-1.345-.976-.875.084.055.125Z"
      fill="#CAA13E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.008 8.824s-.024-.16-.429-.432c-.404-.269-.72-.269-1.01-.497-.224-.18-.457-.592-.609-.728-.147-.135-.171-.523-.171-.523l.496-.416.74-1.068.624-.688.299.416.416.49.231.98.085 1.435-.672 1.03Z"
      fill="#B59544"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.508 10.544a1.823 1.823 0 0 0-.08-.644c-.106-.332-.339-.92-.447-1.141-.044-.245-.011-.264.036-.292.046-.027.223-.128.32-.48.096-.353.396-.364.396-.364l.184-.136.28.7.245.633.076.484.056.413-.132.872-.656.592-.278-.637Z"
      fill="#C89D3A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.364 20.265v-.017a.138.138 0 0 0 .036-.032c.011-.017.02-.036.027-.04a.306.306 0 0 1 .133-.025c.04.008.147.052.204.048.116-.003.252-.092.468-.051.323.06.4.28.587.404.128.088.26.049.28.049h.043c.009 0 .068-.068.1-.065.066.003.072.057.112.06.096.011.28-.049.373-.024a.179.179 0 0 1 .072.296c-.1.092-.195.18-.215.256a.915.915 0 0 1 .071.06 9.422 9.422 0 0 1-2.29-.918Z"
      fill="#CEB052"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.98 17.032s.253-.336.34-.503c.088-.172-.276-2.348-.276-2.348l.731-2.396-.02-.78s.036-.72.12-1.032c.1.18.413.396.481.51.032-.22.14-.684.125-1.179.06.092.203 1.02.203 1.02l.144.624.188.664.209.7.124.484.072.117.06.204.056.22.164.516.096.424.076.768c.016.06.028.12.035.18.003.084-.011.133-.011.147 0 .015.028.185.016.313-.016.128-.016.228-.116.32-.1.091-.164.64-.164.64l-.18-.12s.036-.163-.048-.312a.316.316 0 0 0-.34-.155c-.092.02-.276.049-.336.1-.057.052-.196.212-.324.285-.16.096-.42.104-.56.136-.14.032-.296.128-.46.24a2.564 2.564 0 0 1-.404.213Z"
      fill="#CCA847"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m15.98 20.568.032.018a9.505 9.505 0 0 0 3.03-2.245c-.01-.328-.022-.663-.036-.788-.027-.263-.008-.532-.016-.687a9.993 9.993 0 0 0-.135-.952c-.044-.163-.128-.244-.141-.244a1.95 1.95 0 0 0-.08.384c0 .076-.016.26-.016.307-.011-.003-.016-.032-.016-.043-.016.04-.036.111-.044.12-.008.008.012-.069 0-.085-.011-.016-.032-.008-.027-.048a.46.46 0 0 1 .011-.071s-.049.07-.084.252c-.036.18-.036.185-.048.2-.012.02-.077.085-.08.11-.003.043.06.087.065.11.003.041-.057.229-.076.32-.02.093-.011.273-.032.365-.016.084-.032.133-.087.168.04.008.079.02.079.02s.056.239-.088.443c-.051.071-.064.103-.12.168-.108.12-.192.256-.2.345a.575.575 0 0 1-.011-.08s-.169.196-.24.308c-.092.144-.22.136-.256.171-.036.036-.044.1-.032.153-.032.008-.092.019-.133.144a.304.304 0 0 1-.144.171c-.076.044-.168.057-.215.068.04.011.057.011.076.024-.024.04-.136.104-.26.185a.544.544 0 0 0-.215.26c-.032.068-.08.112-.156.12.032.02.08.065.104.08-.036.007-.096.007-.204.1-.113.093-.152.121-.204.13Z"
      fill="#C39D3C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.729 21.318a.917.917 0 0 1 .2-.106c.252-.1.52-.12.624-.152.1-.032.18-.076.305-.1l-.01.08a9.434 9.434 0 0 1-1.12.278h.001Z"
      fill="#D2BA6B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.384 14.68s-.052.28-.144.456-.192.42-.192.42c0-.054.007-.11.02-.163-.117.068-.4.232-.48.304a1.618 1.618 0 0 0-.237.245c.076-.223.155-.424.168-.516-.116.084-.66.532-.943.828l-.882.714a3.07 3.07 0 0 1-.314.147c-.152.064-.331.12-.464.171a.735.735 0 0 1 .171-.26c.085-.08.337-.353.376-.48.035-.133.044-.212-.003-.324-.044.011-.144.016-.212.036a.414.414 0 0 0-.141.092s.052-.296.163-.576c-.084.003-.228.027-.228.027s.2-.336.544-.57a1.773 1.773 0 0 0-.307.094c-.201.085-.421.21-.584.277.092-.128.739-1.052 1.124-1.912.384-.86.528-1.08.612-1.54.043-.229.032-.566.043-.868.012-.3.049-.568.025-.748.1.125.476.476.488 1.26.012.785-.359 1.845-.752 2.417.096.027.345.06.6-.384.256-.444.253-.568.345-.753.011.092.008.125.008.125s.372-.452.549-1.02c.035.245.14.46-.025.908-.147.405-.34.503-.34.503s.096-.016.237-.1c.024.06.02.128.06.152.04.024.095.065.103.104.044-.065.112-.148.133-.209-.016.128-.028.688.032.972.125-.01.252-.019.34-.244a1 1 0 0 0-.02.54.636.636 0 0 0 .127-.126Z"
      fill="#C0993A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.18 5.76s-.125.052-.337.052c-.184 0-.133-.07-.42-.07-.444 0-1.993.255-2.264.251-.177-.003.595.077.595.077l1.973.027.396-.032.147-.3-.09-.004Z"
      fill="#A88F33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.065 9.617s-.253.192-.36.34c-.106.147-.163.244-.284.363a.247.247 0 0 0 .084-.01s0 .031-.02.04a.115.115 0 0 1 .093.032c-.036.019-.133.116-.057.231.057.087.176.095.176.095s-.027.08.088.072c.247-.012.524-.12.652-.093.128.032.2.044.291.201.096.155.18.18.18.18s.056-.144.043-.36a1.07 1.07 0 0 0 .076-.364l-.084-.62-.367-.464-.476.264-.035.092Z"
      fill="#E3C571"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.516 9.524s.036.084.185.092c-.017.036-.017.041-.012.068l.008.068a.15.15 0 0 0 .044-.032c.008.036-.008.092 0 .133a.295.295 0 0 0 .024.071.142.142 0 0 1 .008-.016c.004-.008.032.087.112.16 0-.011.003-.022.008-.032.001.02.008.04.02.057a.059.059 0 0 1-.017-.012s.008.256.052.389a.187.187 0 0 0 .02-.028c0-.008-.004.072-.012.128-.011.057-.003.136-.003.136a.423.423 0 0 1 .095-.056c.049-.02.128-.08.177-.213a1.42 1.42 0 0 0 .065-.23c.015.03.026.062.032.095.003.04.079.02.079.02l.016-.177.096-.4.088-.247.42-.655.76-.586.664.152.56-.76-.965-.58-.912.096-.829 1.147-.663 1.04-.12.172Z"
      fill="#D8B65B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.296 7.864s-.057.011-.22.096c-.164.085-.277.112-.34.236-.063.125-.068.224-.068.224s.112-.049.177-.065c.067-.016.144-.011.135.016a.188.188 0 0 1-.032.052s.128-.003.125.06a.334.334 0 0 1-.048.163c-.025.032-.125.08-.136.117-.028.076.011.08-.004.14-.01.06-.064.177-.239.38-.18.205-.256.349-.256.349s-.087-.164-.133-.304c-.032.016-.204.111-.204.111l-.398-1.387.008-.092s.036-.043.044-.124c-.06-.02-.068-.036-.147-.112-.08-.076-.144-.168-.277-.231-.02-.036-.043-.085-.14-.104-.098-.02-.156-.036-.156-.036s.052-.02.076-.06c-.06.009-.108.028-.24.025-.132-.003-.147-.008-.22.003-.072.011-.16.044-.192-.068-.035-.027-.112-.003-.176.092-.065.096-.088.172-.212.209a.434.434 0 0 1-.057.155c-.035.06-.092.12-.168.209-.12.14-.1.372-.291.549-.193.176.032-.49.032-.49l.307-.735.875-.856 1.36-.092.132.704.664.228.419.639Z"
      fill="#D3AE4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m14.511 8.02-.57-.824-.4-.308s-.285-.524-.305-.54a3.769 3.769 0 0 0-.456-.052l.032.08a.21.21 0 0 1 .096.064c.076.088.125.253-.048.43.068.023.096.031.155.023-.06.072-.196.224-.204.356-.008.109.06.141.06.141s-.104.12-.109.32a1.3 1.3 0 0 1 .16-.152c.12-.096.285-.204.397-.272a.229.229 0 0 0 .011.084s.209-.171.384-.095c.08.035.044.147.044.147s.108-.04.184.036.185.271.24.348c.024.035.087.103.152.208.088.148.162.303.22.465.003-.065.016-.156.128-.156l-.17-.304Z"
      fill="#CAA13E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.948 10.36s-.04-.101 0-.297c.04-.196.104-.288.125-.576.021-.288.209-.647.209-.647l.52-.236.366.1.109.492-.465.256s-.024.108-.155.196c-.131.087-.312.155-.356.244a.713.713 0 0 0-.056.172s-.133-.028-.212.06c-.085.088-.081.168-.085.236Z"
      fill="#F4EFC8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.997 10.228s-.044.028-.076.096c-.032-.052-.109-.36-.112-.636-.003-.277-.02-.345.044-.44.064-.096.315-.196.28-.368-.036-.163-.185-.231-.368-.184-.128.032-.223.304-.356.44-.1.103-.22.087-.252.144-.044.076-.003.152-.016.2a.969.969 0 0 1-.117.209c-.147.212-.396.511-.429.78.012-.152.004-.155.044-.324l-.024-.04.16-.524.103-.432.232-.724.408-.74.396-.443.413.028.048.62.236 1.163.497.612-.796.536-.315.027Z"
      fill="#EBCC73"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.244 10.448s-.068.016-.092.003c-.024-.013-.048-.027-.04-.043.008-.017.051-.044.051-.057a.045.045 0 0 0-.04-.049c-.037-.004-.049.02-.049.02s-.035-.027-.064-.032a.447.447 0 0 1 .051-.003.505.505 0 0 0-.14-.04c.04-.025.12-.096.171-.096.052 0 .084-.008.076-.036-.008-.027-.048-.068-.092-.084.016-.02.028-.049-.011-.128-.04-.08-.025-.133-.012-.152.012-.024.052-.068.072-.095.019-.028.035-.065.068-.085a.85.85 0 0 1 .12-.051c.056-.02.103-.044.135-.02.036.024.02.057.02.057s.111-.04.212.011c.1.049.344.08.344.08l.088.176-.58.497-.239.12-.048.007Z"
      fill="#E5C66B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.049 9.636s-.18.12-.22.163c.024.004.064.02.048.044-.02.024-.136.108-.2.188-.069.08-.133.18-.156.228a.82.82 0 0 1-.272.188c.133 0 .4-.164.5-.164-.003.049.028.104.084.109.057.004.22.035.44-.1.22-.133.148-.232.24-.297.176-.116.248-.22.345-.285a.63.63 0 0 1 .147-.079s.003-.049.032-.044a.044.044 0 0 1 .036.028s.168-.12.384-.152a.022.022 0 0 1-.012-.011s.016-.009.02-.017c0 0 .01-.016.019-.008.008.008.02.068.036.092.035-.016.103-.168.103-.168l.164-.468v-.427l-.128.025-.96.407-.583.604-.068.144Z"
      fill="#E6BD62"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.812 7.54a.542.542 0 0 0 .148-.06c-.02.052-.02.109-.104.232-.084.123-.087.14-.155.269-.068.132-.076.323-.14.407a.296.296 0 0 1 .091-.027s-.064.057-.092.116c-.027.06-.076.185-.196.26-.12.077-.271.126-.435.305-.163.176-.332.4-.416.48.044-.076.104-.228.12-.328s-.003-.22.024-.353c.028-.133.028-.228.16-.46.133-.231.36-1.035.36-1.035l.488-.156.147.35Z"
      fill="#B6933F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.46 7.244s-.148.212-.188.4c-.04.188-.004.172-.028.264a.344.344 0 0 0 0 .171c.051-.082.121-.15.204-.2.14-.084.252-.144.32-.216.068-.076.124-.2.272-.296-.06-.008-.144-.035-.16-.032.06-.068.24-.171.42-.296.18-.128.169-.18.46-.307-.095.016-.14-.008-.22 0 .032-.068.144-.1.256-.212.112-.112-.071-.277-.071-.277l-.854.516-.412.486Z"
      fill="#C49937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.144 6.86.02-.156.244-.392.256-.687v-.94l-.02-.544.04-.356.031-.113.033-.044.208.108.288.392.028.755-.28 1.193-.8.872-.048-.089Z"
      fill="#DFC068"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.78 3.584s-.128.003-.155.536c-.028.532-.041.812-.06 1.076-.02.264-.065.424-.088.58-.022.155-.035.366-.108.496-.032.06-.1.247-.26.388-.18.156-.449.264-.49.272-.07.016-.431.052-.579.133-.051.027-.14.06-.24.152a3.056 3.056 0 0 0-.643.872c-.288.568-.576 2.172-.576 2.172l.065-.109s.008-.144.152-.396c.14-.253.1-.536.296-1.02.076-.184.171-.424.288-.628.184-.331.408-.616.633-.771.367-.253.771-.308.771-.308l.436-.288s.076-.147.176-.315c.14-.236.32-.5.36-.884.06-.568-.085-.94-.077-1.276.008-.337.011-.585.08-.644.068-.06.019-.038.019-.038Z"
      fill="#A88F33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.78 6.125s.192-.473.28-.892c.016-.084.048-.168.057-.236.04-.397.051-.56 0-.777-.04-.16-.196-.304-.277-.416-.08-.116-.117-.16-.1-.184a.18.18 0 0 1 .14-.06.482.482 0 0 1 .345.16c.125.144.223.632.223.632l.104.645.264.813-1.036.315Z"
      fill="#C99E3D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.584 5.633s-.035.016-.1 0a.144.144 0 0 1-.065.136c-.068-.028-.704.027-.704.027s-.296-.052-.388-.443c-.065-.26.048-.62.011-.856-.057-.348-.136-.416-.144-.524-.008-.109-.016-.136-.016-.204-.036-.008-.057-.02-.092-.02-.008-.032.008-.06-.028-.116.02.008.152.024.308.171.128.12.128.164.147.188.024.024.22.192.304.36.084.166.248.7.285.787a.582.582 0 0 0 .096.152c.094.117.231.31.386.342Z"
      fill="#B58634"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.536 4c.098.158.186.323.263.492.096.215.152.392.272.536-.064-.188-.18-.557-.247-.688A1.576 1.576 0 0 0 9.536 4Z"
      fill="#A88F33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.435 6.66s-.163.04-.467.2c-.1.053-.196.096-.288.137-.24.108-.497.208-.701.264l.024.027s0 .08.044.125c-.024.024-.348.244-.253.98.065-.024.141-.056.152-.056.02.003.025.056.049.056s.104-.032.188-.14c-.003.043-.052.483.208.78.049-.057.172-.245.172-.245l.003-.06s.011-.209.08-.4c.068-.19.2-.331.2-.331l.693-.989-.104-.348Z"
      fill="#E6C367"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.788 8.112a.383.383 0 0 1-.104.052.4.4 0 0 1 .068-.316c.112-.163.356-.375.424-.544.044-.108.025-.38.413-.728.388-.348.54-.468.54-.468l.628-.315.772.304-.383 1.503-.298.704-1.184-.223-.876.031Z"
      fill="#DCBA5A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.24 7.704.147-.184v-.132s.164-.043.34-.223c.176-.18.42-.524.636-.503.215.024.236.467.244.592.008.125.036.408.08.56.048.152-.525.728-.525.728l-.389.296-.533-1.134Z"
      fill="#E9CE77"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.696 9.24s.12-.188.032-.229c.052-.116.147-.24.147-.24s.068-.167.288-.374c.22-.208.356-.345.392-.484.022-.091.034-.184.035-.277.024.02.05.037.076.052.036.016.204.155.18.435-.024.28-.128.397-.128.397s-.1.1-.171.152c-.077.051-.104.111-.232.116a.153.153 0 0 1 .044-.024s-.133-.016-.204.048c-.071.065-.223.264-.299.324l-.16.104Z"
      fill="#CDAE50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.076 6.092a1.949 1.949 0 0 0-.595-.116c-.34-.012-.837.008-1.324.011-.524.003-1-.18-1.66-.212-.109-.065-.384-.348-1.245.252.052-.003.625-.132.824.117.2.248.144.668.117.769-.052.223-.22.548-.288.776-.068.228-.052.348-.1.508-.05.16-.156.24-.093.424.084-.051.128-.051.269-.367.14-.316.111-.54.344-.807.229-.269.608-.636.753-.729.144-.092 1.29-.687 2.492-.12.29-.03.506-.506.506-.506Z"
      fill="#D2A83E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.736 5.872a.149.149 0 0 0-.008-.036.26.26 0 0 0-.043-.064s-.285-.052-.43-.036c-.252.028-.48.34-.587.5-.106.16-.24.408-.383.536a.053.053 0 0 0-.008-.036s.008.011-.008.028c-.016.016-.016.024-.008.032l.024.024c.008 0 .231-.1.536-.384.323-.296.57-.448.7-.5.07-.03.142-.051.215-.064Z"
      fill="#C29637"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.26 4.655s-.051.065-.116.136c-.144.152-.332.324-.492.5-.152.169-.323.3-.516.52-.193.22-.416.464-.472.535a.527.527 0 0 0-.093.248c-.027-.02-.06-.04-.06-.04a.41.41 0 0 0 .049.07c.04.057.104.129.136.172.04.056.068.118.084.185.02.003.144.027.3-.229.155-.255.358-.535.358-.535l.324-.48.204-.408.256-.457.039-.217Z"
      fill="#AC8132"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.592 4.328s-.196.16-.272.256c-.076.096-.255.348-.255.348l.064-.008.329-.29.128-.229.006-.076Z"
      fill="#A88F33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.532 17.188s-.003-.133.072-.212c.076-.08.268-.196.456-.633s.209-.536.209-.536-.337.289-.544.356c.048-.1.076-.171.1-.223-.028-.024-.144-.052-.155-.065.064-.064.1-.223.231-.328.168-.128.476-.348.715-.544.239-.196.708-.652.768-.785.036.052.044.084.044.084s-.236.308-.36.503c-.108.169-.1.264-.1.264l.224-.096s.064.24-.228.604c.128-.049.18-.02.252-.06-.12.076-.285.18-.44.464-.152.285-.36.617-.709.824-.34.218-.536.382-.536.382h.001Z"
      fill="#A67A2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.655 6.26s-.132.277-.152.492c-.003.052-.016.093-.016.152-.003.193.011.408-.032.509-.016-.04-.024-.068-.04-.085-.025.068-.068.28-.104.36a1.685 1.685 0 0 1-.049-.444c.004-.212.008-.252.008-.296-.008.065-.051.152-.067.204-.025-.044-.052-.1-.085-.147-.02.032-.043.08-.064.103a1.48 1.48 0 0 1-.017-.144c-.003-.084-.008-.192-.003-.215a.976.976 0 0 1 .22-.372c.172-.188.348-.548.4-.66l.272-.576h.168l-.244.556s-.147.305-.223.416c-.077.112-.237.433-.308.557.052-.068.095-.103.147-.168.05-.045.19-.241.19-.241Z"
      fill="#8C6228"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.595 4.307a.696.696 0 0 1-.127.232c-.1.12-.316.28-.421.408-.096.124-.288.464-.2.867.031-.088.091-.26.252-.456.16-.196.331-.421.416-.596.084-.176.095-.315.095-.315l.032-.04-.02-.093-.027-.007Z"
      fill="#CBA94C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.872 15.04s-.064-.176-.084-.336c-.02-.16.032-.192-.027-.376-.036-.111-.1-.096-.117-.111-.016-.016-.027-.185-.024-.277a1.037 1.037 0 0 0-.02-.264c-.024-.02-.04-.035-.076-.155-.04-.12-.06-.18-.079-.215-.02-.036-.076-.068-.076-.104 0-.071.065-.108.065-.128-.004-.04-.052-.008-.065-.02-.016-.019.04-.135.02-.151-.009-.008-.065.06-.08.04-.016-.02-.036-.212-.065-.34-.027-.124-.056-.215-.06-.252-.003-.036-.223-.663-.276-.816a3.855 3.855 0 0 1-.109-.391c-.016-.076-.027-.232-.035-.215-.008.016-.003.095-.016.092-.012-.003-.052-.28-.065-.324-.011-.043-.08-.192-.096-.299-.016-.108-.052-.392-.076-.584-.024-.193-.036-.272-.036-.32a1.991 1.991 0 0 0-.02-.353 3.288 3.288 0 0 0-.151-.595c-.109-.272-.397-.968-.448-1.141 0-.044.056-.02.056-.02s.141.353.245.625c.1.272.195.511.22.536.02.024.171.29.24.728.067.437.091.84.132 1.108.02.128.036.264.076.4.044.147.112.3.2.532.077.196.133.36.164.5.036.18.036.316.057.405.02.076.048.228.116.448s.169.503.236.68c.133.352.192.647.213.804.017.161.077.721.06.89h.001Z"
      fill="#A88F33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m15.604 4.288-.008.02s.024.007.019.04a.965.965 0 0 1-.008.133c-.008.056-.024.1-.028.136 0 .076.012.163-.096.38-.032.06-.051.111-.068.147a.438.438 0 0 1-.084.14c.057-.031.26-.16.364-.14a.76.76 0 0 0-.247.223.557.557 0 0 0 .192 0c.18-.027.38-.092.556-.079.193.011.117-.231.117-.231l-.222-.489-.421-.296-.066.016Z"
      fill="#BE9C44"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7 7.948s-.187-.187-.263-.832c-.076-.647-.06-1.6-.06-1.6l-.152-.372s-.032-.247-.112-.34c-.08-.092-.236-.247-.307-.323-.071-.076-.152-.18-.2-.196.023-.04.132-.269.548-.272.416-.003.544.228.587.312.044.085.24.448.312 1.142.068.692.072.744.06.984-.008.132-.052.44-.128.768-.07.279-.145.59-.284.73Z"
      fill="#A17C34"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.112 8.5a.318.318 0 0 0 .18-.04c.06-.004.276.024.443-.188.011.048.04.18-.036.296.04-.04.1-.057.109-.068.003.06.06.244-.18.692.065-.07.14-.067.209-.076.003.085.048.368-.071.52-.08.103-.209.071-.209.071a.406.406 0 0 0 0-.068c-.003-.044-.02-.087-.008-.116a.581.581 0 0 1-.168-.117c-.141-.133-.324-.36-.337-.527-.016-.188.152-.229.152-.229a.18.18 0 0 1-.035-.043c-.009-.028-.017-.071-.049-.107Z"
      fill="#8C6228"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.864 6.464s-.008-.01-.052.04c.008-.05.017-.1.02-.146a.505.505 0 0 1 .079-.12c-.024.048-.04.092-.04.092s.06-.112.147-.18c.06-.048.136-.07.168-.116.036-.049.027-.057.036-.065 0 0 .079-.052.2-.204.016-.02.04-.04.057-.06.027-.01.092-.04.168-.079.08-.044.168-.103.224-.128.108-.049.223-.044.276-.12.04-.011.084-.132.076-.236.06.024.367.215.473.633.076.296-.06.752-.117.972-.056.22-.064.384-.144.484-.1.133-.424.32-.503.413-.068.076-.272.268-.264.407.008.104.136.16.164.18.027.02.027.044.079.032.052-.012.071-.036.092-.036.024.004.024.009.036.009a.116.116 0 0 0 .024-.004s-.008.148-.353.192c-.024.004-.048.012-.079.016.04-.019.065-.019.108-.079-.048-.008-.187-.016-.223-.027a.431.431 0 0 1 .08-.096c.027-.024-.004-.032-.028-.02-.042.03-.082.06-.12.093-.04.036-.076.084-.14.128a.316.316 0 0 1 .06-.277c-.02.003-.057.06-.093.049a.513.513 0 0 1 .011-.177c.02-.073.125-.2.125-.2l.508-.908.108-.688-1.163.226Z"
      fill="#92723A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.837 6.503s-.028.02.027.057c-.008.011-.027.052-.052.08-.027.031-.056.051-.068.079-.024.056-.043.095-.043.12a.59.59 0 0 1-.076.28c-.025.035-.052.095-.072.135-.04.071-.076.128-.084.16a1.678 1.678 0 0 0-.027.212l.048-.06c-.02.04-.04.084-.07.117.019-.017.075-.057.17-.141.133-.112.34-.3.593-.448-.076.027-.14.027-.192.036.04-.04.404-.468.595-.509a.076.076 0 0 0 .016-.051l-.163-.016-.332.07-.048-.255-.222.134Z"
      fill="#B18E3E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.364 7.96s-.044.043-.084.152a.509.509 0 0 1-.08-.109c-.06-.1-.151-.228-.367-.155-.003-.068-.008-.104 0-.152.036-.008.144-.096.253-.223.076-.088.147-.188.195-.316.032-.024.088-.065.16-.112.104-.07.229-.168.248-.276-.048.019-.152.068-.307.06.06-.028.152-.057.14-.177l.044-.027a.16.16 0 0 0-.057-.008c-.003-.012-.008-.028-.035-.02-.028.008-.032.008-.036.02-.011.003-.048 0-.076.019-.027.02-.103.084-.133.095l.028-.048s-.08.008-.136.032c-.104.036-.223.1-.345.163.012-.02.017-.032.025-.035.008-.004.027-.008.027-.012 0-.003-.008-.032-.003-.043.036-.077.079-.15.128-.22.056-.076.068-.185.068-.185l.247-.124.696-.16.452.027-.057.312-.267.546-.228.497-.26.304-.24.175Z"
      fill="#543E26"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.492 6.608s-.272.337-.348.388c.048-.103.348-.72.456-.891-.024-.02-.056-.02.02-.32-.065.152-.088.231-.141.272-.053.04-.06.027-.096.027a.068.068 0 0 0 .008-.04s-.228-.028-.384-.028-.464.084-.636.152c-.136.057-.212.057-.26.092-.049.04-.077.085-.1.096-.02.011-.112.04-.133.071-.02.032-.052.068-.052.076 0 .008-.008.02.016.011a2.25 2.25 0 0 0 .136-.076 3.71 3.71 0 0 1 .285-.147c.231-.092.304-.076.407-.095.109-.02.264-.065.368-.065.103-.003.299 0 .344.008-.02.016-.035.036-.027.104 0 .019-.016.04-.032.087-.049.133-.14.353-.192.464-.071.152-.152.28-.192.36-.04.079-.128.288-.215.4-.088.11-.133.179-.16.203-.028.024-.224.168-.21.22a1.08 1.08 0 0 0 .425-.28c.163-.184.196-.296.323-.396.128-.1.229-.269.288-.408.05-.13.04-.17.102-.285Z"
      fill="#806031"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.633 9.12s-.036.147-.117.22c-.08.071-.22.133-.236.252-.02.12.14.18.14.18s-.087.144-.087.252c0 .112-.003.133.008.24a.107.107 0 0 0-.032.032s.008.103.088.168c.08.065.147.104.187.087a.372.372 0 0 1 .017.04s.06-.151.1-.284c.04-.136.076-.117.092-.3.016-.182.192-.496.192-.496l.12-.268-.196-.152-.276.029Z"
      fill="#B6903C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.997 9.383a1.18 1.18 0 0 0-.112.133c-.051.071-.092.136-.168.164-.076.027-.125.027-.12.103.005.076.076.109.117.147a.19.19 0 0 1 .06.185c.024-.011.068-.024.108-.112.04-.087.323-.62.323-.62h-.208Z"
      fill="#685026"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.112 8.155s.024-.064 0-.111c-.024-.049-.171-.065-.244-.12-.076-.057-.169-.096-.245-.071.012-.028.057-.088.02-.1-.036-.012-.168.048-.204.075-.036.028-.117.06-.133.08-.016.02-.044.056-.06.04-.016-.011-.024-.04-.052-.024-.027.016-.16.124-.184.188a.962.962 0 0 1-.244.364c-.165.16-.237.263-.188.323.049.06.071.017.08.068a.435.435 0 0 1-.009.152c-.02.085-.051.164-.008.18.112.036.22-.032.245-.011.048.043-.028.2.087.231.116.032.231-.027.231-.027l.424-.229.408-.215.209-.412-.112-.345-.022-.036h.001Z"
      fill="#D4B968"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.712 9.14s-.071-.108.016-.203c.088-.096.212-.136.26-.196a.074.074 0 0 0-.035-.024.322.322 0 0 1 .14-.133.135.135 0 0 0-.091-.044c-.08 0-.128.049-.201.049-.071 0-.08-.036-.08-.036s.12-.011.109-.064c-.011-.057-.032-.057-.032-.057s.231-.096.272-.147c.04-.051.035-.112.043-.136.028 0 .188-.084.253-.049.065.036.02.133.02.133s.195-.147.295-.292c.088.008.128-.06.192-.06.08 0 .204.109.228.34.016.133.04.209.016.444-.01.132-.008.416.032.556.028.112.093.1.093.1a.182.182 0 0 1-.057.088c-.044.04-.049.147-.044.188a.78.78 0 0 0 .025.087s-.052.06-.065.1c-.012.04-.065.068-.104.068-.039 0-.02-.003-.07 0-.053.004-.069.012-.101 0-.033-.011-.057-.024-.044-.128.011-.103-.4-.344-.4-.344l-.672-.24h.002Z"
      fill="#CCA849"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.94 10.163s.147.196.753.196c.288 0 .388-.027.448-.043.065-.017.307-.112.552-.4.22-.26.171-.367.171-.367l-.128-.02-.416.057-1.231.524-.15.053h.001Z"
      fill="#585136"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.392 10.212s-.525.117-.525-.215c0-.324.324-.664.405-.723.084-.06.285-.128.285-.128h.483l.093.244-.04.527-.701.295Z"
      fill="#252211"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.876 9.244s-.1-.092-.329.032c-.228.125-.413.384-.424.62-.011.209.172.364.456.372.212.008.34-.016.405-.032l-.1-.124-.008-.868Z"
      fill="#C3B378"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.777 9.296s-.024-.02-.096.02c-.06.031-.147.116-.215.176-.044.035-.072.052-.096.08-.1.119-.185.315-.136.412.048.097.208.209.616.132l-.075-.82h.002Z"
      fill="#E6D89C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.644 9.497s-.065.1-.065.26c0 .164.093.424.432.444.261.016.436-.376.625-.528.144-.116.231-.12.231-.12s-.147-.16-.54-.367c-.388-.209-.824-.236-1.06.084.112-.008.473-.1.473-.1l.176.057-.272.27Z"
      fill="#252211"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.152 9.709c-.011-.025-.02-.057.028-.065.046-.008.068-.003.084.032s.032.065.008.08c-.024.012-.088 0-.12-.048Zm-.076-.229s-.016.012-.008-.01c.003-.028.024-.077.076-.065.052.011.04.067.032.084-.009.016-.052.043-.084.032a.027.027 0 0 1-.016-.04Z"
      fill="#6F674D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.696 9.584a.5.5 0 0 0 .277.092c.147-.003.336-.155.424-.252.051-.057.096-.117.144-.164.04-.04.068-.06.087-.087.028-.032.057-.092.071-.112-.035.028-.087.076-.14.109a1.666 1.666 0 0 1-.21.108c-.043.016-.496.256-.496.256l-.157.05Z"
      fill="#AC924C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.892 8.388s.07-.048.208-.079c.133-.032.4-.057.4-.057l.22.096.087.332-.16.345-.203.128-.232-.372-.32-.392Z"
      fill="#9F8E57"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m7.604 8.685-.076.056s.02-.035.035-.144c.016-.108.1-.372.224-.524.123-.152.12-.144.12-.144a.08.08 0 0 0-.065.016.775.775 0 0 1 .223-.228c.104-.064.144-.084.252-.032.109.053.136.08.216.076.079-.003.147-.087.147-.087s.016.052-.044.172-.296.364-.296.364l-.492.336-.244.139Z"
      fill="#EAC970"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.967 8.348s.357.049.465-.052c.003.012.016.012.016.02a.028.028 0 0 1-.008.016.26.26 0 0 1 .036-.003.21.21 0 0 0 .043.008.252.252 0 0 0 .036-.004.06.06 0 0 1-.024.04c.016 0 .032.004.032.017 0 .013.003.052-.017.06a.073.073 0 0 1-.048-.003.2.2 0 0 0 .024.087c.032.06.1.128.192.108 0 0 .049.117-.155.376-.028.035-.057.084-.092.124a.473.473 0 0 0-.032.096s.344-.133.443-.435c.1-.305.12-.604.1-.884a.455.455 0 0 0-.035-.176c-.049-.1-.185-.084-.24-.028-.079.08-.212.277-.396.413-.188.136-.196.16-.34.22Z"
      fill="#D7BC6B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.54 8.785s-.068.04-.103.192a.627.627 0 0 0 .07.404c.04.06.129.224.313.232.046 0 .091-.01.133-.028a.84.84 0 0 0 .18-.111c.079-.06.144-.112.136-.117-.02-.008-.49-.396-.49-.396l-.176-.197-.063.021Z"
      fill="#585136"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.984 9.429s.096-.008.152-.044c.057-.035-.332-.42-.332-.42l.028.415.152.049Z"
      fill="#453A25"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.571 8.756s-.048.092-.048.116c-.009.08.016.329.035.408.02.084.125.212.26.212.085 0 .201-.052.201-.065 0-.016-.12-.032-.152-.092a.544.544 0 0 1-.032-.192c-.003-.052-.003-.108.017-.128.043-.049.051-.188.051-.188l.156-.288h-.205l-.244.152-.039.065Z"
      fill="#84754B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.511 8.845s.16-.212.305-.26c.144-.05.208-.02.208-.02l-.084.215-.12.133.009.068s-.02.18.1.304c.12.124.209.12.26.12.052 0 .201-.044.277-.224.068-.168.125-.384-.011-.6a.489.489 0 0 0-.413-.224c-.045 0-.401.018-.53.487Z"
      fill="#252211"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.62 9.565c-.06-.028-.003-.196.056-.248a.422.422 0 0 1 .269-.12c.048-.003.095.028.087.06-.01.06-.095.144-.171.204-.105.083-.173.134-.241.104Z"
      fill="#F7F7E7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.383 8.647c.044-.003.1.032.112.08.011.051-.027.155-.112.155-.068 0-.103-.084-.103-.108 0-.02.006-.04.016-.057.003-.005.011-.062.087-.07Z"
      fill="#F8F6DE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.752 8.684s-.111.052-.163.16a.425.425 0 0 0-.032.256c.008.04.049.141.076.177.028.035.065.06.092.056.028-.003.084-.076.084-.12 0-.043.004-.227.057-.328.047-.1-.113-.2-.113-.2Z"
      fill="#D4C38B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.769 8.676c-.02.012-.052.028-.044.049.008.02.076.032.1.08a.17.17 0 0 1 .02.124.197.197 0 0 0 .056-.04c.036-.041.08-.096.117-.096.024 0 .048.011.071.011.036 0 .071-.011.076-.048.008-.049-.068-.093-.112-.084.009-.032.02-.08-.016-.112-.035-.033-.147.024-.171.04-.025.017-.097.076-.097.076Z"
      fill="#E2D59D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.34 12.076.24-.07.067.048s.049.104.125.116c-.025.052-.088.096-.084.133a.112.112 0 0 0 .035.065s-.215.356.209.714c-.1.04-.228.096-.296.128.048.012.152.032.196.072.043.039.043.052.084.076.04.024.064.056.056.07-.027-.015-.12-.064-.136-.019-.016.046-.4.028-.4.028l-.646.125s.024-.065-.044-.125c-.08-.071-.177.003-.28-.076-.136-.104-.14-.223-.185-.269.044-.027.133-.068.345-.096-.008-.016-.035-.064-.02-.108.02-.057.101-.092.077-.16.035-.008.052-.008.14-.12.085-.111.136-.136.201-.144.065-.008.104 0 .224-.111.084-.08.056-.148.056-.148s.055-.017.036-.13v.001Z"
      fill="#CBAC5A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.633 12.112c.003-.016.016-.024.103-.016.088.008.641-.052.791-.06.153-.011.688-.003.949.052.26.055.524.12.652.152.128.035.168.048.163.065-.003.016-.032.031-.048.027-.016-.003-.44-.133-.571-.16-.131-.027-.585-.1-.832-.096-.232.003-.324-.003-.52.02-.196.024-.52.056-.616.043-.096-.011-.076-.011-.072-.027Z"
      fill="#D6BC6F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.935 13.38s.332.18.452.4c.087.163-.052.244-.052.244s.188 0 .163.104c-.01.065-.323.24-.532.332-.212.092-.204.087-.307.103-.1.016-.376-.032-.433.049-.056.08-.032.163-.016.176a.914.914 0 0 0 .148.028s-.028.076-.3.084c-.271.008-.34.027-.356.056-.016.028.052.012.177.032.124.02.299.032.299.032s-.057.049-.204.088c-.168.043-.432.084-.511.132.04.028.1.068.128.072a.81.81 0 0 0-.18.064c.024.017.057.036.057.036s-.136.163-.215.204c-.08.04-.536.252-.693.212-.392-.104-.44-.532-.536-.565-.144-.048-.212.049-.34-.02.057-.04.088-.064.148-.091-.065-.032-.4-.245-.4-.245a2.488 2.488 0 0 0-.116-.223c-.065-.112-.16-.26-.232-.392-.155-.288-.163-.42-.304-.584.024-.032.108-.027.108-.027l1.18.388 2.092.06.544-.776.231.027Z"
      fill="#DFC677"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.837 14.565a.186.186 0 0 0 .043.035c.04.028.1.06.141.109.016-.024.057-.068.128 0 .071.068.16.02.215.035.057.02.06.028.06.028s.032-.028.104-.057c.043-.016.095-.027.152-.043.052-.012.108-.028.147-.028.036.024.163.16.676-.04.484-.188.596-.21.677-.18.008-.02.016-.057.14-.052 0-.052-.103-.228-.103-.228l-.571-.196h-.313l-.936.172-.52.296-.04.15v-.001Z"
      fill="#C4A859"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.524 14.236s.011.088.141.18c.128.092.168.147.168.147s.024-.032.044-.065c.02-.035.036-.076.068-.087.065-.027.212.024.244.016.028-.008.02-.064.049-.064.068-.004.111.043.136.043.024 0 .084-.003.092-.016.008-.013.011-.147.103-.212.1-.071.224-.04.256-.024 0 .024.004.084.068.087.065.003.071-.008.128.011.057.02.125-.003.156.093.027-.008.092-.017.076-.109.032-.024.06-.04.128-.136.016-.024.043-.051.064-.087.057 0 .125-.011.216.068-.028.02-.044.032-.052.052a.581.581 0 0 1 .065.076c.024.032.04.071.07.08.069.018.18-.009.305 0 .12.007.22.05.264.078.016-.008.016-.011.056-.003s.072.011.028-.04c.024.011.052.035.076.011.024-.024.044-.06.111-.068.069-.008.093.003.12-.068.036-.087-.087-.087-.087-.087s.057-.052.12-.12c.076-.071.163-.163.184-.277.036-.208-.168-.236-.168-.236l-.989.304-1.208-.06-1.031.513Z"
      fill="#927D49"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.636 11.38s-.032.04-.052.136c-.02.096-.011.084-.027.152-.016.068-.216.745-.14.973.074.228.203.312.284.497.016.04.032.064.04.1.028.12.004.212.036.332.011.04.04.087.084.136.096.1.253.195.32.263.095.1.231.305.405.324a.583.583 0 0 0 .331-.092c.096-.06.156-.144.256-.192.071-.036.148-.049.215-.065a.974.974 0 0 1 .345-.016c.117.024.392.108.544.108.12-.002.238-.018.353-.048.231-.068.511-.185.696-.237.108-.032.195-.04.285-.06.152-.035.28-.084.352-.176-.048-.056-.108-.144-.432-.14-.367.008-.791.211-1 .244-.209.032-.3.06-.532-.025-.229-.085-.236-.14-.236-.14s-.24-.169-.34-.596c-.1-.428 0-.74.26-1.036.068-.076.052-.144.052-.144s.171-.231.124-.448c-.051-.215-.383-.171-.383-.171l-1.84.321Z"
      fill="#6E6342"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.913 12.1a.168.168 0 0 0-.02.088c.003.043.017.1.147.228.112.111.088.236.088.236s.056.011.209-.06c.12-.057.16.044.16.044a.336.336 0 0 1 .111-.036.245.245 0 0 0 .1-.032s.141.144.264.212c.112.06.177.1.232.06.052-.036.052-.108.048-.14a.42.42 0 0 0-.048-.085c-.036-.052-.092-.112-.096-.16-.008-.112.084-.244.064-.277-.02-.032-.092-.04-.271.025-.186.061-.989-.102-.989-.102Z"
      fill="#39331F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.336 12.824s-.092-.088-.06-.512c.04 0 .079.004.117.012 0 0 .05.328-.057.5Z"
      fill="#292311"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.68 11.057a.25.25 0 0 0 .035-.032c-.032.06-.18.299-.06.676.12.375.42.655.792.668.37.013.565-.168.788-.44.087-.108.187-.244.276-.336.133-.145.237-.185.237-.324 0-.285-.292-.413-.72-.54-.43-.128-.816-.112-1.017-.025-.196.095-.28.196-.332.353Z"
      fill="#252211"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.057 12.951.032-.016s.008-.128.06-.124c.051.008.076.076.07.1-.003.024-.015.065-.067.06-.068.001-.096-.02-.096-.02Z"
      fill="#3F3824"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.913 12.408s.032-.011.07.027c.033 0 .172-.016.216.012.044.027.057.051.057.051s-.164.036-.253 0c-.09-.03-.09-.09-.09-.09Z"
      fill="#2D2815"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.633 12.432a.4.4 0 0 0-.18-.088c-.016-.003-.02.009-.032.009-.008-.004-.011-.028-.011-.028l-.053.028s-.008.011.02.032c.024.02.064.035.076.068.011.032.011.043.016.048.003.003.06 0 .087-.016.028-.016.08-.043.076-.053Z"
      fill="#82764F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.816 12.76s.016-.111.124-.116c.112-.008.133.1.133.1l-.065.065c0-.002-.048-.07-.192-.048Z"
      fill="#2D2816"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.52 12.28s-.06.065-.193.084c-.011-.016-.036-.049 0-.1.036-.052.076-.068.116-.052a.094.094 0 0 1 .077.068Z"
      fill="#574F35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.764 12.36c.003-.017-.008-.02 0-.028.008-.009.052-.025.06-.017.003.004 0 .017 0 .032 0 .016 0 .032-.008.044-.012.016-.044.024-.06.02-.016-.005-.02-.028-.02-.032.008-.004.028-.012.028-.02Zm.276-.175c0-.009.028-.025.044-.025.024 0 .024.02.027.024.008.004.008-.003.016.012.008.014.02.04.012.056-.009.017-.04.028-.049.025a.43.43 0 0 1-.05-.092Z"
      fill="#82764F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.484 12.396s.036.008.084.049c-.016.011-.04.024-.04.024s-.004-.037-.044-.073Z"
      fill="#6E6342"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.405 12.04c-.009-.007.024-.027.043-.024.02.004.028.017.049.02.02.003.024-.008.032-.016.007-.009.035-.004.04 0a.1.1 0 0 1 .008.01.045.045 0 0 1 .016-.031.052.052 0 0 1 .044-.008c.003.011.02.052.016.06-.003.008-.051.02-.06.01.009.02.044.06.049.069.005.008-.036.027-.052.024a.66.66 0 0 1-.186-.113Zm.212-.268a.038.038 0 0 0-.017-.02c-.011-.003-.048 0-.048.02s.032.128.068.184c.04.057.068.104.095.117a.038.038 0 0 0 .049-.016.978.978 0 0 0 .008-.209 1.919 1.919 0 0 0-.016-.285c-.008-.008-.04-.008-.052.008a1.51 1.51 0 0 0-.088.2Z"
      fill="#585136"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.473 12.6s-.057-.035-.112-.01c-.052.023-.049.119-.049.119a.078.078 0 0 0 .072-.008c.035-.024.08-.065.089-.1Z"
      fill="#574F35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.58 12.728c-.004-.032-.033-.032-.033-.048a.036.036 0 0 1 .036-.028c.016 0 .032.02.052.032.02.011.048.032.051.057.004.024-.032.092-.07.092-.04 0-.028-.073-.036-.105Zm.312-.043s-.065.019-.06 0c.005-.02.02-.025.04-.025a.064.064 0 0 1 .04-.02c.01 0 .018.003.025.009 0 0 .044-.02.057-.008.012.011.003.011.01.024.011.015.018.031.02.049 0 .012-.048.04-.087.035-.045-.01-.037-.056-.045-.065Zm.377-.073s.02.01.003.024a.263.263 0 0 1-.117.036c-.048 0-.092.008-.092-.008 0-.017.04-.05.065-.057a.052.052 0 0 1 .04-.02c.02 0 .096-.008.117-.01.02-.004.035.007.024.023-.005.012-.04.012-.04.012Zm.111-.5s-.024.052-.051.052c-.028-.003-.028-.012-.028-.02 0-.011.028-.04.024-.048-.008 0-.027 0-.024-.02 0-.016.028-.035.052-.032a.107.107 0 0 1 .065-.024c.027 0 .051.008.051.024 0 .017-.032.052-.043.06-.013.013-.03.022-.046.008Zm-.369.956s-.032.004-.032.02c0 .008.008.008.02.003a.091.091 0 0 0 .02-.003c.002.003.002.02.027.02.02-.004.039-.01.056-.02.02-.008.036-.016.036-.032-.008-.028-.024-.04-.049-.04a.064.064 0 0 0-.035.007s-.008-.016-.036 0c-.027.017-.024.017-.016.025.014.012.01.02.01.02Zm-.182.169c0-.008.04-.025.051-.02.012.003.044.065.044.071 0 .008-.04.028-.057.028-.016 0-.043-.028-.043-.032 0-.003.019-.008.019-.011.005-.008-.014-.028-.014-.036ZM8.7 13c.008-.003.008-.011.019-.02a.03.03 0 0 1 .012-.004.03.03 0 0 1 .012.002.04.04 0 0 1 .028-.02c.02-.003.035 0 .032.008 0 .025.016.04.016.06 0 .02-.011.044-.052.06a.286.286 0 0 1-.103.008c-.008-.003-.017-.035-.008-.052A.136.136 0 0 1 8.7 13Z"
      fill="#82764F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.752 13.011s-.028.017-.028.025a.071.071 0 0 0-.003.024c0 .005.036-.003.04-.008.002-.003-.009-.032-.009-.04Z"
      fill="#6E6342"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.511 12.935c.016.003.044 0 .065.008.016.008.028.025.011.044-.016.02-.032.049-.068.044-.04-.004-.079-.025-.079-.04a.077.077 0 0 1 .02-.057c.016-.013.024-.005.051.001Z"
      fill="#585136"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.492 12.951s-.052.04-.065.06c-.016.02-.095.12-.12.141a.303.303 0 0 1 .028-.04.166.166 0 0 0-.068.087c-.02.06.108.092.192.117l.117.032a.904.904 0 0 1-.08-.148c-.031-.076-.048-.084-.027-.12.016-.035.04-.06.04-.087a.498.498 0 0 0-.017-.042Z"
      fill="#574F35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.647 13.08a.097.097 0 0 0 .036 0c.024-.004.277-.097.54-.08.198.012.393.044.584.096.332.087.745.26 1.012.36.07.027.14.075.192.095.204.08.212.08.331.1.141.02.285-.027.436-.06.184-.04.5-.06.776-.1.09-.013.178-.033.264-.06 0 0-.22.22-.748.3-.213.032-.43.034-.643.007a1.966 1.966 0 0 1-.364-.064c-.096-.028-.292-.1-.533-.16-.168-.044-.356-.076-.571-.117-.53-.097-1.107-.209-1.312-.317Z"
      fill="#252211"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.052 12.08a9.23 9.23 0 0 1-.397.312l-.4.307c-.135.1-.268.204-.404.304s-.272.196-.416.288a6.74 6.74 0 0 1 .4-.308c.136-.098.277-.195.408-.295l.4-.308c.137-.1.27-.203.409-.3Zm-.707 1.132s.144-.12.323-.288c.223-.209.497-.476.584-.524l-.907.812Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.345 13.212c.071-.071.147-.14.223-.209l.117-.1c.035-.032.076-.068.111-.104.071-.07.141-.147.212-.22.035-.036.073-.07.112-.103a.302.302 0 0 1 .065-.044c.019-.011.04-.032.067-.036-.016.025-.035.036-.051.057-.02.016-.036.036-.052.052-.036.035-.076.068-.112.1-.076.065-.155.128-.231.196-.076.068-.147.14-.223.209-.083.07-.159.137-.238.202Zm.967-.647s-.527.516-.636.6l.636-.6Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.312 12.565a1.725 1.725 0 0 1-.152.155l-.16.152c-.052.052-.1.104-.155.155-.057.049-.109.096-.169.141l.156-.152c.051-.052.108-.095.163-.147l.155-.152c.054-.053.106-.105.162-.152Zm.024.28a3.368 3.368 0 0 1-.171.396c-.136.272-.34.612-.429.785l.6-1.181Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.337 12.845c0 .06-.017.111-.036.163a1.6 1.6 0 0 1-.144.3c-.028.046-.06.095-.084.144l-.164.288c-.056.096-.111.192-.171.284.04-.103.095-.2.147-.296.057-.096.108-.192.16-.291.025-.05.048-.1.068-.152.024-.052.048-.1.068-.147.024-.052.044-.1.068-.148.027-.05.05-.098.087-.145Z"
      fill="#CFB66C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.913 14.171s-.16.213-.144.481c.043-.14.098-.356.144-.48Zm.152.213s-.057.576-.104.86c.067-.328.08-.3.104-.86Zm1.06.893s-.24.704-.245.9c.052-.201.152-.612.245-.9Z"
      fill="#DEC270"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.685 14.128s.388.64.68 1.188c-.08-.276-.26-.78-.68-1.188Z"
      fill="#CBAF59"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.728 15.071c.214.377.406.766.576 1.164a1.778 1.778 0 0 0-.576-1.164Z"
      fill="#E3C677"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.796 16.016c.065-.04.193-.26.305-.316.111-.056.195-.067.296-.18.1-.116.128-.187.348-.28.307-.132.096-.303.096-.303a.982.982 0 0 1 .108-.093c.08-.06.171-.132.163-.26-.011-.215-.051-.528-.228-.709.172-.036.5-.06.704-.111.236-.06.345-.144.345-.144s-.136-.232.084-.465c.22-.233.4-.372.532-.633-.152-.019-.384-.1-.975.125a.745.745 0 0 1 .092.052s-.364.1-.497.212c-.231.196-.26.356-.511.476s-.503.087-.712.184c-.209.097-.24.18-.316.215.016.02-.003.052.028.08-.02.027-.133.211-.248.211.011.044.108.076.108.076s-.07.052-.252.065c.092.096.18.2.42.353-.019.04-.1.1-.067.176.036.076.128.18.497.264-.188.008-.408.052-.704.011-.296-.035-.345-.056-.528-.01.02.018.071.018.117.07-.049.003-.353-.035-.457.1-.108.141-.155.373-.147.528-.056.028-.111.076-.084.176.027.1.171.133.264.196.092.068.1.092.188.076.092-.02.228-.111.307-.111.08 0 .136.06.136.06s.215-.104.236-.085c.02.02.003.144.024.164.022.015.264-.13.329-.17Z"
      fill="#ECD592"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 9.54C16.49 6.93 13.99 6.446 13.99 6.446H6.856l.028 2.66h1.42v5.94H6.856v2.656h6.935c1.672 0 3.012-1.68 3.012-1.68 2.145-3.045.697-6.48.697-6.48Zm-3.671 4.691s-.545.785-1.136.785h-1.184l-.028-5.904H13s.703.147 1.195 1.54c0 0 .652 1.995-.367 3.58Z"
      fill="#fff"
      fillOpacity={0.8}
    />
  </svg>
);

export default SvgDoge;
